import { ApiDocServiceCustomFieldsRepository } from 'services/custom-fields/ApiDocServiceCustomFieldsRepository';
import { QueryKeys } from 'utils/queryKeys';

const CUSTOM_FIELDS_MANAGEMENT_PERMISSION = 'custom_fields_management';

export interface CustomFieldsPermissionsResponse {
  isCustomFieldsManagementAllowed: boolean;
  isCustomFieldsDeniedBasedOnPlan: boolean;
}

export const planBasedPermissionsQueryConfig = {
  queryKey: [QueryKeys.planBasedPersmissions],
  queryFn: async (): Promise<CustomFieldsPermissionsResponse> => {
    const rawData = await new ApiDocServiceCustomFieldsRepository().getUserPermissions();

    const isCustomFieldsManagementAllowed = !!rawData?.[CUSTOM_FIELDS_MANAGEMENT_PERMISSION]?.allowed;
    const isCustomFieldsDeniedBasedOnPlan =
      !isCustomFieldsManagementAllowed && !!rawData?.[CUSTOM_FIELDS_MANAGEMENT_PERMISSION]?.denyReasons?.includes('plan_not_allowed');

    return {
      isCustomFieldsManagementAllowed,
      isCustomFieldsDeniedBasedOnPlan,
    };
  },
  staleTime: 0,
  refetchOnWindowFocus: true,
};
